module.exports = __webpack_public_path__ + "3ba3abf7a8b7c29cb87738aea56c78a7.pdf";